export default __webpack_public_path__ + "static/media/s8.aee11c61.png";